// Reverses markdown-character escaping applied by Lexical's markdown engine
// (e.g. `\*\*bold\*\*` → `**bold**`) so that text-format transformers can
// recognise inner formatting when running recursively inside a wrapper
// transformer (highlight, font-size, etc.).
const UNESCAPE_MARKDOWN_RE = /\\([*_`~\\])/g;

export function unescapeInnerMarkdown(text: string): string {
  return text.replace(UNESCAPE_MARKDOWN_RE, '$1');
}
